import { TWITCH, MIXER, YOUTUBE } from '../constants';
import { Livestream, User } from '../../types/__generated__';

export function getStreamDetails(
  livestream: Livestream | null | undefined,
  owner: User | null | undefined,
) {
  const streamEntries = livestream?.entries;
  if (!streamEntries || streamEntries.length === 0) {
    return null;
  }

  const firstEntry = streamEntries[0];
  return {
    title: createTitle(owner?.name, firstEntry?.streamType),
    streamUrl: createUrl(firstEntry?.streamType, firstEntry?.streamId),
  };
}

const createTitle = (
  ownerName: string | null | undefined,
  streamType: string | null | undefined,
) => {
  if (!ownerName || !streamType) {
    return null;
  }

  return `${ownerName}'s ${streamType} stream`;
};

const createUrl = (
  streamType: string | null | undefined,
  streamId: string | null | undefined,
) => {
  if (!streamId) {
    return null;
  }

  switch (streamType) {
    case TWITCH:
      return `https://player.twitch.tv/?channel=${streamId}`;
    case MIXER:
      return `https://mixer.com/embed/player/${streamId}`;
    case YOUTUBE:
      return `https://www.youtube.com/embed/${streamId}?autoplay=1&playsinline=1`;
    default: {
      return null;
    }
  }
};

export default getStreamDetails;
